import {hideBodyScroll, showBodyScroll} from "../PageHelpers";

/*
 * Окно «поделиться» с QR-кодом (картинку отдаёт /qr/{type}/{id}, см. ShareQrCode.php).
 * - профиль: клик по аватару [data-share-avatar] — видна аватарка, QR открывается кнопкой «QR code»;
 * - маршрут и ивент: кнопка [data-share-qr] — QR виден сразу, вместо кнопки QR — «Download» (PNG).
 *
 * Атрибуты [data-share-qr]: data-url — ссылка на страницу, data-qr — ссылка на картинку QR,
 * data-title, data-image (фон окна и картинка для соцсетей), data-share-label — подпись кнопки Share,
 * data-download / data-download-name — файл для кнопки Download вместо PNG с QR (видео маршрута).
 */

const overlayClass = 'shareWindowOverlay';

function copyUrl(url){
    if(navigator.clipboard && navigator.clipboard.writeText){
        return navigator.clipboard.writeText(url);
    }

    let input = $('<input type="text" readonly>').val(url).appendTo('body');
    input[0].select();
    document.execCommand('copy');
    input.remove();

    return Promise.resolve();
}

function openShareDialog(url, title, imageUrl){
    let shareItem = $('<button type="button" class="shareItem"></button>')
        .data('url', url)
        .data('title', title || '')
        .data('image', imageUrl || '')
        .hide()
        .appendTo('body');

    shareItem.trigger('click');
    shareItem.remove();
}

// Скачать PNG: /qr/route/123 → route-123-qr.png
function downloadQr(qrUrl){
    let name = qrUrl.split('?')[0].split('/').slice(-2).join('-') + '-qr.png';

    clickDownloadLink(qrUrl, name);
}

function clickDownloadLink(href, name){
    let link = $('<a></a>').attr({href: href, download: name}).appendTo('body');
    link[0].click();
    link.remove();
}

/**
 * Скачать файл (видео маршрута). Файл лежит на CDN — другой домен, и атрибут download браузер
 * там игнорирует (просто открывает видео). Поэтому качаем через fetch в blob и отдаём локальной ссылкой.
 * Если CDN не разрешает CORS или fetch упал — открываем файл в новой вкладке.
 */
function downloadFile(url, name){
    notice('Downloading...');

    fetch(url, {mode: 'cors'})
        .then(function(resp){
            if(!resp.ok){
                throw new Error('HTTP ' + resp.status);
            }
            return resp.blob();
        })
        .then(function(blob){
            let blobUrl = URL.createObjectURL(blob);
            clickDownloadLink(blobUrl, name);
            setTimeout(function(){ URL.revokeObjectURL(blobUrl); }, 10000);
        })
        .catch(function(){
            window.open(url, '_blank', 'noopener');
        });
}

function closeShareWindow(){
    $('.' + overlayClass).removeClass('active');

    setTimeout(function(){
        $('.' + overlayClass).remove();

        if($('.slidemenu.active').length === 0){
            showBodyScroll();
        }
    }, 200);
}

function closeQrPanel(overlay){
    overlay.find('.shareWindowMedia').removeClass('qr-visible');
    overlay.find('.shareWindowQrView').removeClass('active');
}

function renderQrIcon(){
    return '<span class="shareWindowQrIcon">' +
        '<span></span><span></span><span></span><span></span>' +
    '</span>';
}

function renderQrPanel(withClose){
    return $('<div class="shareWindowQrView">' +
        (withClose ? '<button type="button" class="shareWindowQrClose" aria-label="Close"><i class="icon-cross"></i></button>' : '') +
        '<div class="shareWindowQrBody"><div class="loader loader-sm"></div></div>' +
    '</div>');
}

function renderAction(action, icon, text){
    return $('<button type="button" class="shareWindowAction" data-action="' + action + '">' +
        '<span class="shareWindowIcon">' + icon + '</span>' +
        '<span>' + text + '</span>' +
    '</button>');
}

/**
 * @param {Object} opts
 * @param {string} opts.image     — фон окна (и аватар в режиме профиля)
 * @param {string} opts.title
 * @param {string} opts.shareLabel
 * @param {boolean} opts.qrOnly   — QR сразу и кнопка Download вместо QR code
 */
function renderOverlay(opts){
    let image = opts.image || '';

    let overlay = $('<div class="' + overlayClass + '"></div>');
    let close = $('<button type="button" class="shareWindowClose" aria-label="Close"><i class="icon-cross"></i></button>');
    let content = $('<div class="shareWindowContent"></div>');
    let media = $('<div class="shareWindowMedia"></div>');
    let panel = $('<div class="shareWindowPanel"></div>');

    if(image){
        overlay[0].style.setProperty('--share-window-bg', 'url("' + image.replace(/"/g, '\\"') + '")');
    }

    panel.append(renderAction('share', '<i class="icon-share"></i>', opts.shareLabel));
    panel.append(renderAction('copy', '<i class="icon-link"></i>', 'Copy<br>link'));

    if(opts.qrOnly){
        // иконка временная, заменить на нужную
        panel.append(renderAction('download', '<i class="icon-download-def"></i>', 'Download'));
    }else{
        panel.append(renderAction('qr', renderQrIcon(), 'QR code'));
        media.append($('<img class="shareWindowImage" alt="">').attr('src', image).attr('alt', opts.title || ''));
    }

    content.append(media).append(panel);
    overlay.append(close).append(content);

    return overlay;
}

/**
 * Открыть окно. opts — как в renderOverlay() плюс url (страница) и qr (картинка QR)
 */
function openShareWindow(opts){
    let overlay = renderOverlay(opts);

    $('.' + overlayClass).remove();
    $('body').append(overlay);
    hideBodyScroll();

    requestAnimationFrame(function(){
        overlay.addClass('active');
    });

    overlay.on('click', function(e){
        if(e.target === overlay[0]){
            closeShareWindow();
        }
    });

    overlay.find('.shareWindowClose').on('click', closeShareWindow);
    overlay.find('[data-action="share"]').on('click', function(){
        closeShareWindow();
        openShareDialog(opts.url, opts.title, opts.image);
    });
    overlay.find('[data-action="copy"]').on('click', function(){
        copyUrl(opts.url).then(function(){
            notice('Copied', {color: 'green'});
        });
    });
    overlay.find('[data-action="qr"]').on('click', function(){
        showQrPanel(overlay, opts.qr, true);
    });
    overlay.find('[data-action="download"]').on('click', function(){
        // свой файл (видео маршрута) — качаем его, иначе PNG с QR
        if(opts.download){
            downloadFile(opts.download, opts.downloadName || 'video.mp4');
        }else if(opts.qr){
            downloadQr(opts.qr);
        }
    });

    if(opts.qrOnly){
        overlay.find('.shareWindowMedia').addClass('qr-only');
        showQrPanel(overlay, opts.qr, false);
    }
}

function openAvatarShare(avatar){
    let img = avatar.find('img.user_avatar').first();

    openShareWindow({
        url:        window.location.href.split('#')[0],
        qr:         avatar.data('qr') || '',
        image:      avatar.data('avatarOrg') || img.attr('src') || '',
        title:      img.attr('alt') || '',
        shareLabel: 'Share<br>profile',
        qrOnly:     false
    });
}

function openQrShare(btn){
    openShareWindow({
        url:        btn.data('url') || window.location.href.split('#')[0],
        qr:         btn.data('qr') || '',
        image:      btn.data('image') || '',
        title:      btn.data('title') || '',
        shareLabel: btn.data('shareLabel') || 'Share',
        download:     btn.data('download') || '',
        downloadName: btn.data('downloadName') || '',
        qrOnly:     true
    });
}

/**
 * @param overlay
 * @param {string} qrUrl — ссылка на PNG, для показа берём SVG
 * @param {boolean} withClose — кнопка возврата к аватару (только профиль)
 */
function showQrPanel(overlay, qrUrl, withClose){
    let qrPanel = overlay.find('.shareWindowQrView');
    let media = overlay.find('.shareWindowMedia');

    if(qrPanel.length > 0){
        media.addClass('qr-visible');
        qrPanel.addClass('active');
        return;
    }

    qrPanel = renderQrPanel(withClose);
    media.append(qrPanel);
    media.addClass('qr-visible');

    requestAnimationFrame(function(){
        qrPanel.addClass('active');
    });

    qrPanel.on('click', function(e){
        e.stopPropagation();
    });

    qrPanel.find('.shareWindowQrClose').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        closeQrPanel(overlay);
    });

    let body = qrPanel.find('.shareWindowQrBody');
    let showError = function(){
        body.html('<span class="shareWindowQrError">QR code unavailable</span>');
    };

    if(!qrUrl){
        showError();
        return;
    }

    // браузер кэширует картинку
    $('<img class="shareWindowQrImage" alt="QR code">')
        .on('load', function(){
            body.empty().append(this);
        })
        .on('error', showError)
        .attr('src', qrUrl + '?format=svg');
}

function shareWindowInit(){
    $(document).off('click.shareWindow', '[data-share-avatar]').on('click.shareWindow', '[data-share-avatar]', function(e){
        if($(e.target).closest('.foto_edit_box').length > 0){
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        openAvatarShare($(this));
    });

    $(document).off('click.qrShare', '[data-share-qr]').on('click.qrShare', '[data-share-qr]', function(e){
        e.preventDefault();
        $(this).closest('.dropdown.active').removeClass('active');
        openQrShare($(this));
    });

    // Ссылка «Download» на странице видео маршрута: href остаётся запасным вариантом без JS
    $(document).off('click.downloadFile', '[data-download-file]').on('click.downloadFile', '[data-download-file]', function(e){
        e.preventDefault();
        downloadFile($(this).attr('href'), $(this).data('downloadFile') || 'video.mp4');
    });

    $(document).off('keydown.shareWindow').on('keydown.shareWindow', function(e){
        if(e.key === 'Escape' && $('.' + overlayClass).length > 0){
            closeShareWindow();
        }
    });
}

if(document.readyState === 'loading'){
    window.addEventListener('load', shareWindowInit);
}else{
    shareWindowInit();
}
